module.exports = __webpack_public_path__ + "img/craneFrontLeftOutline.bf802b74.svg";